import { QueryOptions, queryOptions } from '@tanstack/react-query';
import { service } from '@maia/quotation';

export type Notes = Awaited<ReturnType<(typeof service)['getNotes']>>;

export function getNotesOptions(
  guid: string,
  search: Record<string, unknown> = {},
  initialData: QueryOptions<Notes>['initialData'] = undefined,
) {
  return queryOptions({
    queryKey: ['notes', guid],
    queryFn: async () => await service.getNotes(guid, search),
    initialData,
  });
}
